export { AmplifyService } from './amplify.service';
export { default as AmplifyModules } from './amplify.compose.service';
//# sourceMappingURL=index.js.map